export const FETCH_RESIDENTSDATA_INIT_ACTION =
  "FETCH_RESIDENTSDATA_INIT_ACTION";
export const FETCH_RESIDENTSDATA_SUCCESS_ACTION =
  FETCH_RESIDENTSDATA_INIT_ACTION + "_SUCCESS";
export const FETCH_RESIDENTSDATA_FAIL_ACTION =
  FETCH_RESIDENTSDATA_INIT_ACTION + "_ERROR";

export const UPDATE_RESIDENTSDATA_INIT_ACTION =
  "UPDATE_RESIDENTSDATA_INIT_ACTION";
export const UPDATE_RESIDENTSDATA_SUCCESS_ACTION =
  UPDATE_RESIDENTSDATA_INIT_ACTION + "_SUCCESS";
export const UPDATE_RESIDENTSDATA_FAIL_ACTION =
  UPDATE_RESIDENTSDATA_INIT_ACTION + "_ERROR";
